// Copyright (c) 2025 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

// DO NOT EDIT.
// Code generated in 2025 by '/pkg/go/foundational/mime/generate/client/generator.go'
// This file is intended for version control.


/** getContentType returns the content types accepted by the API. **/
export const getContentTypes = (): string[] => {
	return [
		"text/plain",
		"text/csv",
		"text/vtt",
		"text/markdown",
		"application/json",
		"application/pdf",
		"google/slides",
		"google/documents",
		"image/jpeg",
		"image/tiff",
		"image/bmp",
		"image/webp",
		"application/java-vm",
		"audio/x-wav",
		"audio/x-aiff",
		"audio/basic",
		"application/x-midi",
		"audio/midi",
		"application/vnd.ms-htmlhelp",
		"application/chm",
		"application/x-chm",
		"text/x-java-source",
		"text/x-c++src",
		"text/x-groovy",
		"application/pkcs7-signature",
		"application/pkcs7-mime",
		"application/dif+xml",
		"image/vnd.dwg",
		"application/x-ibooks+zip",
		"application/epub+zip",
		"application/x-elf",
		"application/x-sharedlib",
		"application/x-executable",
		"application/x-msdownload",
		"application/x-coredump",
		"application/x-object",
		"application/atom+xml",
		"application/rss+xml",
		"application/x-font-adobe-metric",
		"application/x-font-ttf",
		"image/x-ozi",
		"application/x-snodas",
		"application/x-ecrg-toc",
		"image/envisat",
		"application/x-doq2",
		"application/x-rs2",
		"application/x-gsag",
		"application/x-ers",
		"application/fits",
		"application/x-pnm",
		"image/adrg",
		"application/x-generic-bin",
		"application/x-bt",
		"application/x-zmap",
		"image/eir",
		"application/x-ace2",
		"application/grass-ascii-grid",
		"application/x-l1b",
		"application/x-gsc",
		"image/jp2",
		"image/hfa",
		"image/fits",
		"image/raster",
		"application/x-epsilon",
		"image/x-srp",
		"application/x-envi-hdr",
		"application/x-ctable2",
		"application/x-srtmhgt",
		"application/jaxa-pal-sar",
		"application/x-ndf",
		"application/sdts-raster",
		"application/x-gtx",
		"application/x-rst",
		"application/x-xyz",
		"application/terragen",
		"application/x-gs7bg",
		"image/arg",
		"application/elas",
		"image/big-gif",
		"application/x-geo-pdf",
		"application/x-ctg",
		"application/aaigrid",
		"application/x-lcp",
		"application/x-nwt-grc",
		"application/x-fast",
		"application/x-usgs-dem",
		"application/x-nwt-grd",
		"application/x-ingr",
		"application/x-envi",
		"application/x-rik",
		"application/x-blx",
		"application/x-wcs",
		"image/ceos",
		"application/x-ngs-geoid",
		"application/x-r",
		"application/x-http",
		"application/x-til",
		"application/x-pds",
		"application/x-rasterlite",
		"application/x-gmt",
		"application/x-msgn",
		"image/ilwis",
		"application/aig",
		"application/x-rmf",
		"image/x-hdf5-image",
		"image/sar-ceos",
		"application/x-kro",
		"application/vrt",
		"application/x-netcdf",
		"image/nitf",
		"image/png",
		"image/geotiff",
		"image/x-mff2",
		"application/x-webp",
		"image/ida",
		"application/x-gsbg",
		"application/x-ntv2",
		"application/x-coasp",
		"application/x-los-las",
		"application/x-tsx",
		"application/x-bag",
		"image/fit",
		"application/x-lan",
		"application/x-map",
		"application/x-dods",
		"application/jdem",
		"application/gff",
		"application/x-isis2",
		"application/x-isis3",
		"application/xpm",
		"application/x-pcidsk",
		"application/x-gxf",
		"application/x-wms",
		"application/x-cosar",
		"image/bsb",
		"application/x-grib",
		"application/x-mbtiles",
		"application/x-cappi",
		"application/x-rpf-toc",
		"image/x-mff",
		"image/x-dimap",
		"image/x-pcraster",
		"application/x-ppi",
		"application/x-sdat",
		"application/pcisdk",
		"application/x-cpg",
		"application/leveller",
		"image/sgi",
		"image/x-fujibas",
		"image/x-airsar",
		"application/x-e00-grid",
		"application/x-kml",
		"application/x-p-aux",
		"application/x-doq1",
		"application/dted",
		"application/x-dipex",
		"application/geotopic",
		"text/iso19139+xml",
		"application/x-grib2",
		"application/x-hdf",
		"application/x-asp",
		"application/xhtml+xml",
		"application/vnd.wap.xhtml+xml",
		"text/html",
		"image/bpg",
		"image/x-bpg",
		"image/x-icon",
		"image/vnd.wap.wbmp",
		"image/x-xcf",
		"image/vnd.adobe.photoshop",
		"text/vnd.iptc.anpa",
		"application/x-isatab",
		"application/vnd.apple.iwork",
		"application/vnd.apple.numbers",
		"application/vnd.apple.keynote",
		"application/vnd.apple.pages",
		"message/rfc822",
		"application/x-matlab-data",
		"application/mbox",
		"application/vnd.ms-outlook-pst",
		"application/x-msaccess",
		"application/x-mspublisher",
		"application/x-tika-msoffice",
		"application/vnd.ms-excel",
		"application/sldworks",
		"application/x-tika-msworks-spreadsheet",
		"application/vnd.ms-powerpoint",
		"application/x-tika-msoffice-embedded; format=ole10_native",
		"application/vnd.ms-project",
		"application/x-tika-ooxml-protected",
		"application/msword",
		"application/vnd.ms-outlook",
		"application/vnd.visio",
		"application/vnd.ms-excel.sheet.3",
		"application/vnd.ms-excel.sheet.2",
		"application/vnd.ms-excel.workspace.3",
		"application/vnd.ms-excel.workspace.4",
		"application/vnd.ms-excel.sheet.4",
		"application/x-tnef",
		"application/ms-tnef",
		"application/vnd.ms-tnef",
		"application/vnd.ms-excel.sheet.macroenabled.12",
		"application/vnd.ms-powerpoint.presentation.macroenabled.12",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.template",
		"application/vnd.openxmlformats-officedocument.presentationml.template",
		"application/vnd.ms-excel.addin.macroenabled.12",
		"application/vnd.ms-word.document.macroenabled.12",
		"application/vnd.ms-excel.template.macroenabled.12",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.template",
		"application/vnd.ms-powerpoint.slideshow.macroenabled.12",
		"application/vnd.ms-powerpoint.addin.macroenabled.12",
		"application/vnd.ms-word.template.macroenabled.12",
		"application/x-tika-ooxml",
		"application/vnd.openxmlformats-officedocument.presentationml.slideshow",
		"audio/mpeg",
		"video/3gpp2",
		"audio/aac",
		"video/mp4",
		"video/quicktime",
		"audio/mp4",
		"audio/m4a",
		"audio/x-m4a",
		"application/mp4",
		"video/x-m4v",
		"video/3gpp",
		"image/x-ms-bmp",
		"image/gif",
		"application/x-vnd.oasis.opendocument.graphics-template",
		"application/vnd.sun.xml.writer",
		"application/x-vnd.oasis.opendocument.text",
		"application/x-vnd.oasis.opendocument.text-web",
		"application/x-vnd.oasis.opendocument.spreadsheet-template",
		"application/vnd.oasis.opendocument.formula-template",
		"application/vnd.oasis.opendocument.presentation",
		"application/vnd.oasis.opendocument.image-template",
		"application/x-vnd.oasis.opendocument.graphics",
		"application/vnd.oasis.opendocument.chart-template",
		"application/vnd.oasis.opendocument.presentation-template",
		"application/x-vnd.oasis.opendocument.image-template",
		"application/vnd.oasis.opendocument.formula",
		"application/x-vnd.oasis.opendocument.image",
		"application/vnd.oasis.opendocument.spreadsheet-template",
		"application/x-vnd.oasis.opendocument.chart-template",
		"application/x-vnd.oasis.opendocument.formula",
		"application/vnd.oasis.opendocument.spreadsheet",
		"application/vnd.oasis.opendocument.text-web",
		"application/vnd.oasis.opendocument.text-template",
		"application/vnd.oasis.opendocument.text",
		"application/x-vnd.oasis.opendocument.formula-template",
		"application/x-vnd.oasis.opendocument.spreadsheet",
		"application/x-vnd.oasis.opendocument.chart",
		"application/vnd.oasis.opendocument.text-master",
		"application/x-vnd.oasis.opendocument.text-master",
		"application/x-vnd.oasis.opendocument.text-template",
		"application/vnd.oasis.opendocument.graphics",
		"application/vnd.oasis.opendocument.graphics-template",
		"application/x-vnd.oasis.opendocument.presentation",
		"application/vnd.oasis.opendocument.image",
		"application/x-vnd.oasis.opendocument.presentation-template",
		"application/vnd.oasis.opendocument.chart",
		"application/x-bzip",
		"application/x-bzip2",
		"application/gzip",
		"application/x-gzip",
		"application/x-xz",
		"application/x-tar",
		"application/x-tika-unix-dump",
		"application/java-archive",
		"application/x-7z-compressed",
		"application/x-archive",
		"application/x-cpio",
		"application/zip",
		"application/x-rar-compressed",
		"application/rtf",
		"video/x-flv",
		"application/xml",
		"text/xml",
		"image/svg+xml",
		"application/x-fictionbook+xml",
		"audio/x-oggflac",
		"audio/x-flac",
		"application/kate",
		"application/ogg",
		"audio/x-oggpcm",
		"video/x-oggyuv",
		"video/x-dirac",
		"video/x-ogm",
		"audio/ogg",
		"video/x-ogguvs",
		"video/theora",
		"video/x-oggrgb",
		"video/ogg",
		"audio/opus",
		"audio/ogg; codecs=opus",
		"audio/speex",
		"audio/ogg; codecs=speex",
		"audio/vorbis",
		"application/msword",
		"application/vnd.ms-excel",
		"application/vnd.ms-powerpoint",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"application/vnd.openxmlformats-officedocument.presentationml.presentation",
		"video/webm",
	]
}

/** getMaxSizeForContentType returns the maximum size in bytes for the content type. **/
// export const getMaxSizeForContentType = (contentType: string): number => {
// 	switch (contentType) {
//
// 		case 'text/plain':
// 			return 786432000;
//
// 		case 'text/csv':
// 			return 786432000;
//
// 		case 'text/vtt':
// 			return 786432000;
//
// 		case 'text/markdown':
// 			return 786432000;
//
// 		case 'application/json':
// 			return 786432000;
//
// 		case 'application/pdf':
// 			return 786432000;
//
// 		case 'google/slides':
// 			return 786432000;
//
// 		case 'google/documents':
// 			return 786432000;
//
// 		case 'image/jpeg':
// 			return 786432000;
//
// 		case 'image/tiff':
// 			return 786432000;
//
// 		case 'image/bmp':
// 			return 786432000;
//
// 		case 'image/webp':
// 			return 786432000;
//
// 		case 'application/java-vm':
// 			return 786432000;
//
// 		case 'audio/x-wav':
// 			return 786432000;
//
// 		case 'audio/x-aiff':
// 			return 786432000;
//
// 		case 'audio/basic':
// 			return 786432000;
//
// 		case 'application/x-midi':
// 			return 786432000;
//
// 		case 'audio/midi':
// 			return 786432000;
//
// 		case 'application/vnd.ms-htmlhelp':
// 			return 786432000;
//
// 		case 'application/chm':
// 			return 786432000;
//
// 		case 'application/x-chm':
// 			return 786432000;
//
// 		case 'text/x-java-source':
// 			return 786432000;
//
// 		case 'text/x-c++src':
// 			return 786432000;
//
// 		case 'text/x-groovy':
// 			return 786432000;
//
// 		case 'application/pkcs7-signature':
// 			return 786432000;
//
// 		case 'application/pkcs7-mime':
// 			return 786432000;
//
// 		case 'application/dif+xml':
// 			return 786432000;
//
// 		case 'image/vnd.dwg':
// 			return 786432000;
//
// 		case 'application/x-ibooks+zip':
// 			return 786432000;
//
// 		case 'application/epub+zip':
// 			return 786432000;
//
// 		case 'application/x-elf':
// 			return 786432000;
//
// 		case 'application/x-sharedlib':
// 			return 786432000;
//
// 		case 'application/x-executable':
// 			return 786432000;
//
// 		case 'application/x-msdownload':
// 			return 786432000;
//
// 		case 'application/x-coredump':
// 			return 786432000;
//
// 		case 'application/x-object':
// 			return 786432000;
//
// 		case 'application/atom+xml':
// 			return 786432000;
//
// 		case 'application/rss+xml':
// 			return 786432000;
//
// 		case 'application/x-font-adobe-metric':
// 			return 786432000;
//
// 		case 'application/x-font-ttf':
// 			return 786432000;
//
// 		case 'image/x-ozi':
// 			return 786432000;
//
// 		case 'application/x-snodas':
// 			return 786432000;
//
// 		case 'application/x-ecrg-toc':
// 			return 786432000;
//
// 		case 'image/envisat':
// 			return 786432000;
//
// 		case 'application/x-doq2':
// 			return 786432000;
//
// 		case 'application/x-rs2':
// 			return 786432000;
//
// 		case 'application/x-gsag':
// 			return 786432000;
//
// 		case 'application/x-ers':
// 			return 786432000;
//
// 		case 'application/fits':
// 			return 786432000;
//
// 		case 'application/x-pnm':
// 			return 786432000;
//
// 		case 'image/adrg':
// 			return 786432000;
//
// 		case 'application/x-generic-bin':
// 			return 786432000;
//
// 		case 'application/x-bt':
// 			return 786432000;
//
// 		case 'application/x-zmap':
// 			return 786432000;
//
// 		case 'image/eir':
// 			return 786432000;
//
// 		case 'application/x-ace2':
// 			return 786432000;
//
// 		case 'application/grass-ascii-grid':
// 			return 786432000;
//
// 		case 'application/x-l1b':
// 			return 786432000;
//
// 		case 'application/x-gsc':
// 			return 786432000;
//
// 		case 'image/jp2':
// 			return 786432000;
//
// 		case 'image/hfa':
// 			return 786432000;
//
// 		case 'image/fits':
// 			return 786432000;
//
// 		case 'image/raster':
// 			return 786432000;
//
// 		case 'application/x-epsilon':
// 			return 786432000;
//
// 		case 'image/x-srp':
// 			return 786432000;
//
// 		case 'application/x-envi-hdr':
// 			return 786432000;
//
// 		case 'application/x-ctable2':
// 			return 786432000;
//
// 		case 'application/x-srtmhgt':
// 			return 786432000;
//
// 		case 'application/jaxa-pal-sar':
// 			return 786432000;
//
// 		case 'application/x-ndf':
// 			return 786432000;
//
// 		case 'application/sdts-raster':
// 			return 786432000;
//
// 		case 'application/x-gtx':
// 			return 786432000;
//
// 		case 'application/x-rst':
// 			return 786432000;
//
// 		case 'application/x-xyz':
// 			return 786432000;
//
// 		case 'application/terragen':
// 			return 786432000;
//
// 		case 'application/x-gs7bg':
// 			return 786432000;
//
// 		case 'image/arg':
// 			return 786432000;
//
// 		case 'application/elas':
// 			return 786432000;
//
// 		case 'image/big-gif':
// 			return 786432000;
//
// 		case 'application/x-geo-pdf':
// 			return 786432000;
//
// 		case 'application/x-ctg':
// 			return 786432000;
//
// 		case 'application/aaigrid':
// 			return 786432000;
//
// 		case 'application/x-lcp':
// 			return 786432000;
//
// 		case 'application/x-nwt-grc':
// 			return 786432000;
//
// 		case 'application/x-fast':
// 			return 786432000;
//
// 		case 'application/x-usgs-dem':
// 			return 786432000;
//
// 		case 'application/x-nwt-grd':
// 			return 786432000;
//
// 		case 'application/x-ingr':
// 			return 786432000;
//
// 		case 'application/x-envi':
// 			return 786432000;
//
// 		case 'application/x-rik':
// 			return 786432000;
//
// 		case 'application/x-blx':
// 			return 786432000;
//
// 		case 'application/x-wcs':
// 			return 786432000;
//
// 		case 'image/ceos':
// 			return 786432000;
//
// 		case 'application/x-ngs-geoid':
// 			return 786432000;
//
// 		case 'application/x-r':
// 			return 786432000;
//
// 		case 'application/x-http':
// 			return 786432000;
//
// 		case 'application/x-til':
// 			return 786432000;
//
// 		case 'application/x-pds':
// 			return 786432000;
//
// 		case 'application/x-rasterlite':
// 			return 786432000;
//
// 		case 'application/x-gmt':
// 			return 786432000;
//
// 		case 'application/x-msgn':
// 			return 786432000;
//
// 		case 'image/ilwis':
// 			return 786432000;
//
// 		case 'application/aig':
// 			return 786432000;
//
// 		case 'application/x-rmf':
// 			return 786432000;
//
// 		case 'image/x-hdf5-image':
// 			return 786432000;
//
// 		case 'image/sar-ceos':
// 			return 786432000;
//
// 		case 'application/x-kro':
// 			return 786432000;
//
// 		case 'application/vrt':
// 			return 786432000;
//
// 		case 'application/x-netcdf':
// 			return 786432000;
//
// 		case 'image/nitf':
// 			return 786432000;
//
// 		case 'image/png':
// 			return 786432000;
//
// 		case 'image/geotiff':
// 			return 786432000;
//
// 		case 'image/x-mff2':
// 			return 786432000;
//
// 		case 'application/x-webp':
// 			return 786432000;
//
// 		case 'image/ida':
// 			return 786432000;
//
// 		case 'application/x-gsbg':
// 			return 786432000;
//
// 		case 'application/x-ntv2':
// 			return 786432000;
//
// 		case 'application/x-coasp':
// 			return 786432000;
//
// 		case 'application/x-los-las':
// 			return 786432000;
//
// 		case 'application/x-tsx':
// 			return 786432000;
//
// 		case 'application/x-bag':
// 			return 786432000;
//
// 		case 'image/fit':
// 			return 786432000;
//
// 		case 'application/x-lan':
// 			return 786432000;
//
// 		case 'application/x-map':
// 			return 786432000;
//
// 		case 'application/x-dods':
// 			return 786432000;
//
// 		case 'application/jdem':
// 			return 786432000;
//
// 		case 'application/gff':
// 			return 786432000;
//
// 		case 'application/x-isis2':
// 			return 786432000;
//
// 		case 'application/x-isis3':
// 			return 786432000;
//
// 		case 'application/xpm':
// 			return 786432000;
//
// 		case 'application/x-pcidsk':
// 			return 786432000;
//
// 		case 'application/x-gxf':
// 			return 786432000;
//
// 		case 'application/x-wms':
// 			return 786432000;
//
// 		case 'application/x-cosar':
// 			return 786432000;
//
// 		case 'image/bsb':
// 			return 786432000;
//
// 		case 'application/x-grib':
// 			return 786432000;
//
// 		case 'application/x-mbtiles':
// 			return 786432000;
//
// 		case 'application/x-cappi':
// 			return 786432000;
//
// 		case 'application/x-rpf-toc':
// 			return 786432000;
//
// 		case 'image/x-mff':
// 			return 786432000;
//
// 		case 'image/x-dimap':
// 			return 786432000;
//
// 		case 'image/x-pcraster':
// 			return 786432000;
//
// 		case 'application/x-ppi':
// 			return 786432000;
//
// 		case 'application/x-sdat':
// 			return 786432000;
//
// 		case 'application/pcisdk':
// 			return 786432000;
//
// 		case 'application/x-cpg':
// 			return 786432000;
//
// 		case 'application/leveller':
// 			return 786432000;
//
// 		case 'image/sgi':
// 			return 786432000;
//
// 		case 'image/x-fujibas':
// 			return 786432000;
//
// 		case 'image/x-airsar':
// 			return 786432000;
//
// 		case 'application/x-e00-grid':
// 			return 786432000;
//
// 		case 'application/x-kml':
// 			return 786432000;
//
// 		case 'application/x-p-aux':
// 			return 786432000;
//
// 		case 'application/x-doq1':
// 			return 786432000;
//
// 		case 'application/dted':
// 			return 786432000;
//
// 		case 'application/x-dipex':
// 			return 786432000;
//
// 		case 'application/geotopic':
// 			return 786432000;
//
// 		case 'text/iso19139+xml':
// 			return 786432000;
//
// 		case 'application/x-grib2':
// 			return 786432000;
//
// 		case 'application/x-hdf':
// 			return 786432000;
//
// 		case 'application/x-asp':
// 			return 786432000;
//
// 		case 'application/xhtml+xml':
// 			return 786432000;
//
// 		case 'application/vnd.wap.xhtml+xml':
// 			return 786432000;
//
// 		case 'text/html':
// 			return 786432000;
//
// 		case 'image/bpg':
// 			return 786432000;
//
// 		case 'image/x-bpg':
// 			return 786432000;
//
// 		case 'image/x-icon':
// 			return 786432000;
//
// 		case 'image/vnd.wap.wbmp':
// 			return 786432000;
//
// 		case 'image/x-xcf':
// 			return 786432000;
//
// 		case 'image/vnd.adobe.photoshop':
// 			return 786432000;
//
// 		case 'text/vnd.iptc.anpa':
// 			return 786432000;
//
// 		case 'application/x-isatab':
// 			return 786432000;
//
// 		case 'application/vnd.apple.iwork':
// 			return 786432000;
//
// 		case 'application/vnd.apple.numbers':
// 			return 786432000;
//
// 		case 'application/vnd.apple.keynote':
// 			return 786432000;
//
// 		case 'application/vnd.apple.pages':
// 			return 786432000;
//
// 		case 'message/rfc822':
// 			return 786432000;
//
// 		case 'application/x-matlab-data':
// 			return 786432000;
//
// 		case 'application/mbox':
// 			return 786432000;
//
// 		case 'application/vnd.ms-outlook-pst':
// 			return 786432000;
//
// 		case 'application/x-msaccess':
// 			return 786432000;
//
// 		case 'application/x-mspublisher':
// 			return 786432000;
//
// 		case 'application/x-tika-msoffice':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel':
// 			return 786432000;
//
// 		case 'application/sldworks':
// 			return 786432000;
//
// 		case 'application/x-tika-msworks-spreadsheet':
// 			return 786432000;
//
// 		case 'application/vnd.ms-powerpoint':
// 			return 786432000;
//
// 		case 'application/x-tika-msoffice-embedded; format=ole10_native':
// 			return 786432000;
//
// 		case 'application/vnd.ms-project':
// 			return 786432000;
//
// 		case 'application/x-tika-ooxml-protected':
// 			return 786432000;
//
// 		case 'application/msword':
// 			return 786432000;
//
// 		case 'application/vnd.ms-outlook':
// 			return 786432000;
//
// 		case 'application/vnd.visio':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.sheet.3':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.sheet.2':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.workspace.3':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.workspace.4':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.sheet.4':
// 			return 786432000;
//
// 		case 'application/x-tnef':
// 			return 786432000;
//
// 		case 'application/ms-tnef':
// 			return 786432000;
//
// 		case 'application/vnd.ms-tnef':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.sheet.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/vnd.ms-powerpoint.presentation.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
// 			return 786432000;
//
// 		case 'application/vnd.openxmlformats-officedocument.presentationml.template':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.addin.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/vnd.ms-word.document.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel.template.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
// 			return 786432000;
//
// 		case 'application/vnd.ms-powerpoint.slideshow.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/vnd.ms-powerpoint.addin.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/vnd.ms-word.template.macroenabled.12':
// 			return 786432000;
//
// 		case 'application/x-tika-ooxml':
// 			return 786432000;
//
// 		case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
// 			return 786432000;
//
// 		case 'audio/mpeg':
// 			return 786432000;
//
// 		case 'video/3gpp2':
// 			return 786432000;
//
// 		case 'audio/aac':
// 			return 786432000;
//
// 		case 'video/mp4':
// 			return 786432000;
//
// 		case 'video/quicktime':
// 			return 786432000;
//
// 		case 'audio/mp4':
// 			return 786432000;
//
// 		case 'audio/m4a':
// 			return 786432000;
//
// 		case 'audio/x-m4a':
// 			return 786432000;
//
// 		case 'application/mp4':
// 			return 786432000;
//
// 		case 'video/x-m4v':
// 			return 786432000;
//
// 		case 'video/3gpp':
// 			return 786432000;
//
// 		case 'image/x-ms-bmp':
// 			return 786432000;
//
// 		case 'image/gif':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.graphics-template':
// 			return 786432000;
//
// 		case 'application/vnd.sun.xml.writer':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.text':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.text-web':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.spreadsheet-template':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.formula-template':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.presentation':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.image-template':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.graphics':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.chart-template':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.presentation-template':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.image-template':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.formula':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.image':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.spreadsheet-template':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.chart-template':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.formula':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.spreadsheet':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.text-web':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.text-template':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.text':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.formula-template':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.spreadsheet':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.chart':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.text-master':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.text-master':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.text-template':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.graphics':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.graphics-template':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.presentation':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.image':
// 			return 786432000;
//
// 		case 'application/x-vnd.oasis.opendocument.presentation-template':
// 			return 786432000;
//
// 		case 'application/vnd.oasis.opendocument.chart':
// 			return 786432000;
//
// 		case 'application/x-bzip':
// 			return 786432000;
//
// 		case 'application/x-bzip2':
// 			return 786432000;
//
// 		case 'application/gzip':
// 			return 786432000;
//
// 		case 'application/x-gzip':
// 			return 786432000;
//
// 		case 'application/x-xz':
// 			return 786432000;
//
// 		case 'application/x-tar':
// 			return 786432000;
//
// 		case 'application/x-tika-unix-dump':
// 			return 786432000;
//
// 		case 'application/java-archive':
// 			return 786432000;
//
// 		case 'application/x-7z-compressed':
// 			return 786432000;
//
// 		case 'application/x-archive':
// 			return 786432000;
//
// 		case 'application/x-cpio':
// 			return 786432000;
//
// 		case 'application/zip':
// 			return 786432000;
//
// 		case 'application/x-rar-compressed':
// 			return 786432000;
//
// 		case 'application/rtf':
// 			return 786432000;
//
// 		case 'video/x-flv':
// 			return 786432000;
//
// 		case 'application/xml':
// 			return 786432000;
//
// 		case 'text/xml':
// 			return 786432000;
//
// 		case 'image/svg+xml':
// 			return 786432000;
//
// 		case 'application/x-fictionbook+xml':
// 			return 786432000;
//
// 		case 'audio/x-oggflac':
// 			return 786432000;
//
// 		case 'audio/x-flac':
// 			return 786432000;
//
// 		case 'application/kate':
// 			return 786432000;
//
// 		case 'application/ogg':
// 			return 786432000;
//
// 		case 'audio/x-oggpcm':
// 			return 786432000;
//
// 		case 'video/x-oggyuv':
// 			return 786432000;
//
// 		case 'video/x-dirac':
// 			return 786432000;
//
// 		case 'video/x-ogm':
// 			return 786432000;
//
// 		case 'audio/ogg':
// 			return 786432000;
//
// 		case 'video/x-ogguvs':
// 			return 786432000;
//
// 		case 'video/theora':
// 			return 786432000;
//
// 		case 'video/x-oggrgb':
// 			return 786432000;
//
// 		case 'video/ogg':
// 			return 786432000;
//
// 		case 'audio/opus':
// 			return 786432000;
//
// 		case 'audio/ogg; codecs=opus':
// 			return 786432000;
//
// 		case 'audio/speex':
// 			return 786432000;
//
// 		case 'audio/ogg; codecs=speex':
// 			return 786432000;
//
// 		case 'audio/vorbis':
// 			return 786432000;
//
// 		case 'application/msword':
// 			return 786432000;
//
// 		case 'application/vnd.ms-excel':
// 			return 786432000;
//
// 		case 'application/vnd.ms-powerpoint':
// 			return 786432000;
//
// 		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
// 			return 786432000;
//
// 		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
// 			return 786432000;
//
// 		case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
// 			return 786432000;
//
// 		case 'video/webm':
// 			return 786432000;
//
// 		default:
// 			throw new Error(`Unknown content type: ${contentType}`);
// 	}
// }

export const supportedExtensions = [
    ".txt",
    ".text",
    ".csv",
    ".vtt",
    ".md",
    ".markdown",
    ".mdown",
    ".mkdn",
    ".mkd",
    ".mdwn",
    ".mdtxt",
    ".mdtext",
    ".json",
    ".pdf",
    ".gslides",
    ".gdoc",
    ".jpg",
    ".jpeg",
    ".jpe",
    ".jif",
    ".jfif",
    ".jfi",
    ".tif",
    ".tiff",
    ".bmp",
    ".webp",
    ".class",
    ".wav",
    ".aiff",
    ".aif",
    ".aifc",
    ".au",
    ".snd",
    ".mid",
    ".midi",
    ".mid",
    ".midi",
    ".chm",
    ".chm",
    ".chm",
    ".java",
    ".cpp",
    ".cxx",
    ".cc",
    ".groovy",
    ".p7s",
    ".p7m",
    ".p7c",
    ".dif",
    ".dwg",
    ".ibooks",
    ".epub",
    ".elf",
    ".so",
    ".exe",
    ".exe",
    ".dmp",
    ".o",
    ".atom",
    ".rss",
    ".afm",
    ".ttf",
    ".ozi",
    ".snodas",
    ".ecrg",
    ".envi",
    ".doq2",
    ".rs2",
    ".gsag",
    ".ers",
    ".fits",
    ".pnm",
    ".adrg",
    ".bin",
    ".bt",
    ".zmap",
    ".eir",
    ".ace2",
    ".grd",
    ".l1b",
    ".gsc",
    ".jp2",
    ".hfa",
    ".fits",
    ".ras",
    ".eps",
    ".srp",
    ".hdr",
    ".ctable2",
    ".srtm",
    ".jaxa",
    ".ndf",
    ".sdts",
    ".gtx",
    ".rst",
    ".xyz",
    ".ter",
    ".gs7bg",
    ".arg",
    ".elas",
    ".biggif",
    ".geopdf",
    ".ctg",
    ".grd",
    ".lcp",
    ".grc",
    ".fast",
    ".dem",
    ".grd",
    ".ingr",
    ".envi",
    ".rik",
    ".blx",
    ".wcs",
    ".ceos",
    ".geoid",
    ".r",
    ".http",
    ".til",
    ".pds",
    ".rst",
    ".gmt",
    ".msgn",
    ".mpr",
    ".mpl",
    ".aig",
    ".rmf",
    ".h5",
    ".sar",
    ".kro",
    ".vrt",
    ".nc",
    ".cdf",
    ".ntf",
    ".nitf",
    ".png",
    ".tif",
    ".tiff",
    ".mff2",
    ".webp",
    ".ida",
    ".gsbg",
    ".ntv2",
    ".coasp",
    ".las",
    ".tsx",
    ".bag",
    ".fit",
    ".fits",
    ".lan",
    ".map",
    ".dods",
    ".jdem",
    ".gff",
    ".gff3",
    ".isis",
    ".isis",
    ".pm",
    ".pcidsk",
    ".gxf",
    ".wms",
    ".cosar",
    ".bsb",
    ".grb",
    ".grb1",
    ".grb2",
    ".mbtiles",
    ".cappi",
    ".toc",
    ".mff",
    ".dim",
    ".PCRaster",
    ".ppi",
    ".sdat",
    ".pcidsk",
    ".cpg",
    ".lev",
    ".sgi",
    ".rgb",
    ".rgba",
    ".bw",
    ".fujibas",
    ".airsar",
    ".e00",
    ".kml",
    ".aux",
    ".doq1",
    ".dted",
    ".dipex",
    ".gt",
    ".xml",
    ".grb2",
    ".hdf",
    ".hdf4",
    ".hdf5",
    ".he2",
    ".he5",
    ".asp",
    ".xhtml",
    ".xht",
    ".xhtml",
    ".html",
    ".htm",
    ".shtml",
    ".bpg",
    ".bpg",
    ".ico",
    ".wbmp",
    ".xcf",
    ".psd",
    ".anpa",
    ".isatab",
    ".pages",
    ".key",
    ".numbers",
    ".numbers",
    ".key",
    ".pages",
    ".eml",
    ".mat",
    ".mbox",
    ".pst",
    ".mdb",
    ".pub",
    ".doc",
    ".xls",
    ".ppt",
    ".xls",
    ".xlt",
    ".xla",
    ".sldprt",
    ".sldasm",
    ".slddrw",
    ".xlr",
    ".ppt",
    ".pot",
    ".pps",
    ".ppa",
    ".doc",
    ".xls",
    ".ppt",
    ".mpp",
    ".mpt",
    ".docx",
    ".xlsx",
    ".pptx",
    ".doc",
    ".msg",
    ".vsd",
    ".vst",
    ".vss",
    ".vsw",
    ".xlw",
    ".xls",
    ".xlw",
    ".xlw",
    ".xlt",
    ".tnef",
    ".tnef",
    ".tnef",
    ".xlsm",
    ".pptm",
    ".xltx",
    ".potx",
    ".xlam",
    ".docm",
    ".xltm",
    ".dotx",
    ".ppsm",
    ".ppam",
    ".dotm",
    ".docx",
    ".xlsx",
    ".pptx",
    ".ppsx",
    ".mp3",
    ".mpga",
    ".mp2",
    ".mp2a",
    ".3g2",
    ".aac",
    ".mp4",
    ".m4a",
    ".m4p",
    ".m4b",
    ".m4r",
    ".m4v",
    ".mov",
    ".qt",
    ".m4a",
    ".m4a",
    ".m4a",
    ".mp4",
    ".m4v",
    ".3gp",
    ".3gpp",
    ".bmp",
    ".gif",
    ".otg",
    ".sxw",
    ".odt",
    ".oth",
    ".ots",
    ".otf",
    ".odp",
    ".oti",
    ".odg",
    ".otc",
    ".otp",
    ".oti",
    ".odf",
    ".odi",
    ".ots",
    ".otc",
    ".odf",
    ".ods",
    ".oth",
    ".ott",
    ".odt",
    ".otf",
    ".ods",
    ".odc",
    ".odm",
    ".odm",
    ".ott",
    ".odg",
    ".otg",
    ".odp",
    ".odi",
    ".otp",
    ".odc",
    ".bz",
    ".bz2",
    ".gz",
    ".gz",
    ".xz",
    ".tar",
    ".bin",
    ".jar",
    ".7z",
    ".a",
    ".ar",
    ".cpio",
    ".zip",
    ".rar",
    ".rtf",
    ".flv",
    ".xml",
    ".xml",
    ".svg",
    ".svgz",
    ".fb2",
    ".oga",
    ".ogg",
    ".flac",
    ".kate",
    ".ogg",
    ".oga",
    ".ogg",
    ".ogv",
    ".drc",
    ".ogm",
    ".ogg",
    ".oga",
    ".ogv",
    ".ogg",
    ".ogv",
    ".ogv",
    ".opus",
    ".opus",
    ".spx",
    ".spx",
    ".ogg",
    ".doc",
    ".xls",
    ".xlt",
    ".xla",
    ".ppt",
    ".pot",
    ".pps",
    ".ppa",
    ".docx",
    ".xlsx",
    ".pptx",
    ".webm",
]
